import type { WorkshopNavItem } from './workshopNavTypes';

export const WORKSHOP_SALES_NAV: WorkshopNavItem[] = [
    { resource: 'jobCardInvoice', label: 'Job Card Invoice' },
    { resource: 'counterSales', label: 'Counter Sales' },
    { resource: 'counterSalesReturn', label: 'Counter Sales Return' },
];
